import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBAPI from '@/util/SBAPI';
import SBText from './SBText';

@Component({
    components: {
        SBText,
    },
})
export default class SBOrderHistory extends Mixins(SBComponentVue) {

    public error: string = "";

    public detail: boolean = false;

    @Prop({
        type: Object,
        default: (): SBAPI.PlanOrderHistory => {
            return SBAPI.planOrderHistory();
        },
    })
    public value!: SBAPI.PlanOrderHistory;

    @Emit("input")
    public input(val: SBAPI.PlanOrderHistory) {
        return val;
    }
}
